import axios from 'axios';
import { action, Module, mutation, VuexModule } from 'vuex-class-component';
import { vxm } from '@/store.vuex';

@Module({ namespacedPath: 'workpreference/' })
export class WorkPreferenceStore extends VuexModule {
  private workPreferenceInfo: any = {
    desiredLocations: [],
    shiftPreferences: [],
    meta: {},
  };

  private fieldConfig: any = [];

  get FieldConfig() {
    return this.fieldConfig;
  }

  get WorkPreferenceInfo() {
    return this.workPreferenceInfo;
  }

  @mutation
  public setFieldConfig(payload) {
    if (payload) {
      payload = JSON.parse(payload);
      this.fieldConfig = payload.fieldConfig;
    }
  }

  @mutation
  public setWorkPreferenceInfo(payload) {
    if (!payload.shiftPreferences) {
      payload.shiftPreferences = [];
    }
    if (!payload.desiredLocations) {
      payload.desiredLocations = [];
    }
    if (!payload.employmentPreference) {
      payload.employmentPreference = '';
    }
    if (!payload.periodForSalary) {
      payload.periodForSalary = '';
    }
    if (!payload.jobAvailability) {
      payload.jobAvailability = '';
    }
    if (!payload.desiredMaxSalary) {
      payload.desiredMaxSalary = '';
    }
    if (!payload.desiredMinSalary) {
      payload.desiredMinSalary = '';
    }
    this.workPreferenceInfo = payload;
  }

  @action({ mode: 'mutate' })
  public async fetchWorkPreference() {
    const response = await axios.get(
      '/wl-profile-svc/api/v2/work-preferences',
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
        },
      },
    );
    this.setWorkPreferenceInfo(response.data.data);
    vxm.users.setWorkHistory(response.data.data)
    this.setFieldConfig(response.data.data.workPreferenceFieldConfig);
  }

  @action({ mode: 'mutate' })
  public async saveWorkPreference(payload) {
    vxm.users.setWorkHistory(payload)
    const response = await axios.post(
      '/wl-profile-svc/api/v2/work-preferences',
      payload,
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
        },
      },
    );
    return response.data;
  }
}
